module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc8-2f6d9ba6546f63e3954c91343b8fbda0.jpg";